import { useLocalStorage } from 'usehooks-ts';
import { useLiveCountdown } from '@app/shared/hooks/useLiveCountdown';

type MediaCooldownState = Record<string, { lastAt?: number }>;

export const useItemCountdown = (storageKey: string, id: string, intervalMs: number) => {
  const [data] = useLocalStorage<Record<string, MediaCooldownState | undefined> | undefined>(
    storageKey,
    {}
  );

  const lastAt = data?.[storageKey]?.[id]?.lastAt ?? 0;

  return useLiveCountdown(lastAt, intervalMs);
};
